import { CategoryType, FrequencyType, TransactionType } from './enums';
// 🪙 BUZUNARUL - Loading Message Templates System
// Mesaje cu personalitatea "Buzunarul" pentru toate stările de loading
export const LOADING_MESSAGES = {
    GENERIC: 'Verificăm buzunarul...',
    WITH_CONTEXT: (context) => `Organizăm ${context} în buzunar...`,
    DATA: 'Strângem toate monedele...',
    MORE: 'Căutăm mai multe în buzunar...',
    TRANSACTIONS: 'Organizăm mișcările din buzunar...',
    NAVIGATION: 'Explorăm buzunarul...',
    SAVING: 'Punem totul la loc în buzunar...',
    SAVING_TRANSACTION: 'Adăugăm în buzunar...',
    SPECIFIC: (item) => `Organizăm ${item} în buzunar...`,
    DATE_CONTEXT: (month, year) => `Verificăm buzunarul pentru ${month} ${year}...`,
    // 🪙 BUZUNARUL - Loading Messages Extinse cu personalitatea buzunar
    // Export/Import
    EXPORTING: 'Pregătim buzunarul pentru export... 📦',
    IMPORTING: 'Punem datele noi în buzunar... 📥',
    // Operații pe lots
    BULK_UPDATING: 'Actualizăm mai multe mișcări în buzunar... ⚡',
    BULK_DELETING: 'Scoatem mai multe tranzacții din buzunar... 🗑️',
    // Calcule și sincronizări
    CALCULATING_BALANCES: 'Calculăm soldurile buzunarului... 📊',
    SYNCING_DATA: 'Sincronizăm buzunarul cu norul... ☁️',
    // Specific pentru pagini
    LOADING_DASHBOARD: 'Pregătim tabloul de bord al buzunarului... 📱',
    LOADING_SETTINGS: 'Încarcăm setările buzunarului... ⚙️',
    LOADING_PROFILE: 'Verificăm profilul buzunarului... 👤',
    // Grid și formulare
    LOADING_GRID: 'Organizăm grid-ul buzunarului... 🗂️',
    LOADING_FORM: 'Pregătim formularul buzunarului... 📝',
    LOADING_FORM_FIELDS: (count) => `Se organizează formularul cu ${count} câmpuri în buzunar...`,
    // Mesaje specifice cu date
    LOADING_GRID_FOR_MONTH: (month, year) => `Încarcăm grid-ul pentru ${month} ${year} în buzunar... 📅`,
    // Operații specifice  
    REGENERATING: 'Se regenerează...'
};
// 🪙 BUZUNARUL - Empty State Message Templates System  
// Mesaje prietenoase pentru stările goale cu personalitatea "Buzunarul"
export const EMPTY_STATE_MESSAGES = {
    NO_ITEMS: (entity) => `Buzunarul nu conține ${entity}`,
    NO_DATA_FILTER: (filter) => `Buzunarul pare gol pentru ${filter}`,
    NO_TRANSACTIONS: 'Buzunarul e curat ca nou! Prima tranzacție e mereu cea mai grea să o adaugi. Hai să începem! 🪙',
    NO_SUBCATEGORIES: 'Acest compartiment din buzunar e gol. Vrei să adaugi ceva?',
    GENERIC: 'Buzunarul pare să fie gol aici... 🧐',
    NO_SELECTION: 'Alege un compartiment din buzunar pentru a vedea și organiza conținutul.',
    NO_FILTERS: 'Buzunarul e deschis complet - nu ai filtre active',
    EMPTY_TRANSACTION_LIST: 'Buzunarul e gol',
    NO_ACCOUNTS: 'Nu există conturi definite.'
};
// 🚀 PHASE 2.3 - Design Tokens System
// Consolidarea magic numbers și design constants
export const DESIGN_TOKENS = {
    SIZES: {
        SPINNER: {
            SMALL: 16,
            MEDIUM: 32,
            LARGE: 48,
            XLARGE: 64
        },
        BREAKPOINTS: {
            SM: 640,
            MD: 768,
            LG: 1024,
            XL: 1280
        },
        SPACING: {
            GRID_GAP: 16,
            MODAL_PADDING: 24,
            CARD_PADDING: 16
        }
    },
    DATE_RANGES: {
        MIN_YEAR: 2020,
        MAX_YEAR: 2030,
        DEFAULT_RANGE: 10
    },
    TRANSITIONS: {
        DEFAULT: 'transition-all duration-200 ease-in-out',
        FAST: 'transition-all duration-100 ease-in-out',
        SLOW: 'transition-all duration-300 ease-in-out'
    }
};
// Constante pentru monedă
export const CURRENCY = {
    SUFFIX: ' RON', // Include spațiu pentru concatenare directă
    SYMBOL: 'RON',
};
// 🪙 Constante pentru aplicație
export const APP = {
    NAME: 'Buzunarul',
    TITLE: 'Buzunarul - Aplicația Ta de Buget',
    DESCRIPTION: 'Organizează-ți banii în buzunar cu ușurință 🪙',
};
// Toate textele UI vizibile
export const LABELS = {
    TYPE: 'Tip',
    AMOUNT: 'Sumă',
    CATEGORY: 'Categorie',
    SUBCATEGORY: 'Subcategorie',
    DATE: 'Dată',
    RECURRING: 'Recurent',
    FREQUENCY: 'Frecvență',
    TYPE_FILTER: 'Tip tranzacție:',
    CATEGORY_FILTER: 'Categoria:',
    FORM: 'adăugare tranzacție', // pentru aria-label pe <form>
    DESCRIPTION: 'Descriere',
    // Constante pentru pagina de autentificare/înregistrare
    EMAIL: 'Email',
    PAROLA: 'Parolă',
    CONFIRMA_PAROLA: 'Confirmă parola',
    // Filtre extinse
    SEARCH_FILTER: 'Caută:',
    DATE_FROM_FILTER: 'De la data:',
    DATE_TO_FILTER: 'Până la data:',
    AMOUNT_MIN_FILTER: 'Suma minimă:',
    AMOUNT_MAX_FILTER: 'Suma maximă:',
    // Transaction type labels
    INCOME_TYPE: 'Venit',
    EXPENSE_TYPE: 'Cheltuială',
    // 🎯 TASK 13 - MODAL LABELS
    EXPORT_TITLE: 'Export Tranzacții',
    EXPORT_FORMAT_LABEL: 'Format export*:',
    YEAR_LABEL: 'An:',
    MONTH_LABEL: 'Luna:',
    CATEGORY_FILTER_LABEL: 'Categoria:',
    TIME_PERIOD_TITLE: 'Perioada de timp',
    TIME_PERIOD_DESCRIPTION: 'Selectați intervalul temporal pentru export',
    // POPOVER LABELS
    EDIT_TRANSACTION_TITLE: 'Editează tranzacția',
    ADD_TRANSACTION_TITLE: 'Adaugă tranzacție',
    AMOUNT_RON_LABEL: 'Suma (RON)',
    DESCRIPTION_LABEL: 'Descriere',
    RECURRING_LABEL: 'Recurentă',
    FREQUENCY_LABEL: 'Frecvență',
    // FREQUENCY OPTIONS
    FREQUENCY_MONTHLY: 'Lunar',
    FREQUENCY_WEEKLY: 'Săptămânal',
    FREQUENCY_YEARLY: 'Anual',
    // SHOW/HIDE DETAILS
    SHOW_DETAILS: 'Arată detalii recurență',
    HIDE_DETAILS: 'Ascunde detalii recurență',
};
// Constante pentru confirmări
export const CONFIRMATIONS = {
    DELETE_TITLE: 'Confirmă ștergerea',
    DELETE_MESSAGE: 'Această acțiune nu poate fi anulată.',
    // 🎯 TASK 5 - Final Amount Confirmation
    FINAL_AMOUNT_TITLE: 'Confirmă suma',
    FINAL_AMOUNT_MESSAGE: 'Suma este finală și completă?',
    FINAL_AMOUNT_CONFIRM: 'Da, finală',
    FINAL_AMOUNT_CANCEL: 'Nu încă',
    // 🪙 BUZUNARUL - Confirmări extinse cu personalitatea buzunar
    // Confirmări pentru ștergere tranzacții
    DELETE_TRANSACTION: 'Sigur scoți această mișcare din buzunar? Nu o poți pune înapoi după! 🗑️',
    DELETE_TRANSACTION_PERMANENT: 'Această mișcare va fi scoasă definitiv din buzunar. Ești sigur? ⚠️',
    // Confirmări pentru conturi
    DELETE_ACCOUNT: (accountName) => `Sigur vrei să ștergi buzunarul "${accountName}"? Toate mișcările se vor pierde definitiv! 💀`,
    RESET_ACCOUNT: 'Resetezi buzunarul la început? Toate mișcările vor dispărea! 🔄',
    // Confirmări pentru export/import
    EXPORT_ALL_DATA: 'Exportezi tot conținutul buzunarului? 📦',
    IMPORT_OVERWRITE: 'Datele noi vor înlocui ce ai în buzunar. Continui? 📥',
    // Confirmări pentru modificări mari
    BULK_EDIT: (count) => `Modifici ${count} mișcări dintr-odată în buzunar. Ești sigur? 📝`,
    CLEAR_ALL_FILTERS: 'Ștergi toate filtrele și vezi întreg buzunarul? 🔍',
    // Confirmări pentru setări
    CHANGE_START_MONTH: 'Schimbarea lunii de început va reorganiza totul în buzunar și poate declanșa migrarea mișcărilor anterioare. Continui? 📅'
};
// Constante pentru ARIA labels
export const ARIA_LABELS = {
    DELETE_CONFIRMATION: 'Dialog de confirmare ștergere',
    EDIT_CELL: (id) => `Editează celula ${id}`,
    // 🪙 BUZUNARUL - Accessibility Labels extinse cu personalitatea buzunar
    // Acțiuni de închidere
    CLOSE_DIALOG: 'Închide fereastra buzunarului',
    CLOSE_CATEGORY_EDITOR: 'Închide editorul de compartimente',
    // Acțiuni pentru tranzacții
    MARK_TRANSACTION_COMPLETE: 'Marchează mișcarea ca finalizată în buzunar ✓',
    EDIT_TRANSACTION_FULL: 'Deschide editorul complet pentru această mișcare ✏️',
    // Selecții și configurări
    SELECT_BALANCE_START_MONTH: 'Alege luna de început pentru calculul soldului buzunarului 📅',
    // Template pentru celule dinamice
    EDITING_CELL: 'Editează celula pentru',
    CELL_WITH_VALUE: 'Celulă cu valoarea',
};
export const TITLES = {
    TRANZACTII: 'Mișcările din Buzunar',
    GRID_LUNAR: 'Planificatorul Lunar',
    OPTIUNI: 'Setările Buzunarului',
    SITUATIA_ZILNICA: 'Situația de Azi',
    FORM_TITLE: (type) => `Pune ${type === TransactionType.INCOME ? 'bani' : 'o cheltuială'} în buzunar`,
    // 🪙 LOGIN PAGE - Mesaj cald de întâmpinare
    LOGIN_WELCOME: 'Bine ai venit la Buzunarul tău! 🪙',
};
export const PLACEHOLDERS = {
    // ...existing
    ADD_SUBCATEGORY: 'Adaugă subcategorie nouă',
    SELECT: 'Alege',
    AMOUNT: 'Introdu suma',
    DATE: 'Selectează data',
    DESCRIPTION: 'Adaugă o descriere (opțional)',
    CATEGORY_EDITOR_SUBCATEGORY: 'Adaugă subcategorie nouă', // added
    SEARCH: 'Caută...',
    AMOUNT_MIN_FILTER: 'Suma minimă',
    AMOUNT_MAX_FILTER: 'Suma maximă',
    // 🚨 AUDIT FIX - Adăugare placeholders hardcodate din LunarGrid
    EDIT_TRANSACTION: 'Editează...',
    ADD_TRANSACTION: 'Adaugă...',
    SUBCATEGORY_NAME: 'Nume subcategorie...',
    // 🚨 TASK 5.4 - Placeholder pentru amount field în QuickAddModal
    AMOUNT_PLACEHOLDER: '0.00',
    // 🎯 TASK 13 - MODAL PLACEHOLDERS
    ALL_MONTHS: 'Toate lunile',
    ALL_CATEGORIES: 'Toate categoriile',
    // 🪙 BUZUNARUL - Texte extinse cu personalitate (din ADDITIONAL_PLACEHOLDERS)
    // Descrieri și comentarii
    ADD_DESCRIPTION_BUZUNAR: 'Spune-ne despre această mișcare... 💭',
    SEARCH_DESCRIPTION_BUZUNAR: 'Caută prin mișcările din buzunar... 🔍',
    // Selecții pentru formulare
    SELECT_CATEGORY_BUZUNAR: 'Alege compartimentul din buzunar 🗂️',
    SELECT_SUBCATEGORY_BUZUNAR: 'Selectează sub-compartimentul 📁',
    SELECT_TYPE_FIRST: 'Selectează mai întâi tipul mișcării ⬆️',
    // Intrări de valori
    ENTER_VALUE: 'Cât punem în buzunar? 💰',
    ENTER_AMOUNT_BUZUNAR: 'Introdu suma pentru buzunar 🪙',
    // Căutări și filtre
    SEARCH_PLACEHOLDER: 'Caută prin buzunar... 🔎',
    FILTER_PLACEHOLDER: 'Filtrează conținutul buzunarului 🎯',
    // Nume și denumiri
    ACCOUNT_NAME: 'Numele buzunarului (ex: Buzunar Principal) 👛',
    DESCRIPTION_OPTIONAL: 'Descriere opțională pentru buzunar... 📖',
    // Filtre sumă
    AMOUNT_MIN: 'Min',
    AMOUNT_MAX: 'Max',
    SELECT_FREQUENCY: 'Selectează frecvența',
    CUSTOM_DATE_RANGE_TITLE: 'Interval personalizat',
    CUSTOM_DATE_RANGE_DESCRIPTION: 'Opțional - specificați un interval exact de date',
};
export const BUTTONS = {
    // ...existing
    RENAME: 'Redenumește',
    ADD: 'Adaugă',
    CANCEL: 'Anulează',
    DONE: 'Gata',
    EDIT: 'Editează',
    DELETE: 'Șterge',
    DELETE_CONFIRM: 'Confirmă ștergerea',
    NEXT_PAGE: 'Înainte',
    PREV_PAGE: 'Înapoi',
    ADD_SUBCATEGORY: 'Adaugă subcategorie',
    MANAGE_CATEGORIES: 'Gestionare categorii',
    EXPORT: 'Exportă',
    DELETE_TRANSACTION: 'Șterge tranzacția',
    // Constante pentru autentificare/înregistrare
    LOGIN: 'Autentificare',
    REGISTER: 'Crează cont',
    LOGIN_WITH_GOOGLE: 'Continuă cu Google',
    REGISTER_WITH_GOOGLE: 'Continuă cu Google',
    LOADING: 'Se încarcă...',
    RESET_FILTERS: 'Resetează filtre',
    RESET_ALL_FILTERS: 'Resetează toate',
    // 🎯 TASK 13 - MODAL BUTTONS
    SAVE: 'Salvează',
    SAVE_ALL: 'Salvează toate',
    SAVING: 'Se salvează...',
    EXPORT_IN_PROGRESS: 'Export în progres...',
    EXPORTING_COUNT: (count) => `Exportă ${count} tranzacții`,
    EXPORTING_WITH_PROGRESS: (progress) => `Exportând... ${progress}%`,
    // 🎯 TASK 5.5 - Button pentru adăugare rapidă din popover
    ADD_MULTIPLE_TRANSACTIONS: 'Adaugă mai multe tranzacții',
};
// 🍞 TOAST NOTIFICATIONS - Notificări temporare
export const TOAST = {
    // Toast actions
    CLOSE: 'Închide notificarea',
    // Toast variants and titles
    INFO: {
        TITLE: 'Informație',
        DEFAULT_MESSAGE: 'Informație disponibilă'
    },
    SUCCESS: {
        TITLE: 'Succes',
        DEFAULT_MESSAGE: 'Operația a fost finalizată cu succes'
    },
    WARNING: {
        TITLE: 'Atenție',
        DEFAULT_MESSAGE: 'Verificați informațiile introduse'
    },
    ERROR: {
        TITLE: 'Eroare',
        DEFAULT_MESSAGE: 'A apărut o eroare neașteptată'
    },
    // 🪙 BUZUNARUL - Toast messages cu personalitate caldă și prietenoasă
    TRANSACTION: {
        ADDED: 'Perfect! Buzunarul e la curent cu tot ce se întâmplă 👌',
        UPDATED: 'Excelent! Am actualizat mișcarea din buzunar ✨',
        DELETED: 'Am scos asta din buzunar. Vrei să o readaugi?',
        DELETED_PERMANENT: 'Am golit buzunarul de această înregistrare 🗑️',
        RESTORED: 'Înregistrarea e înapoi în buzunar! 🔄',
        RESTORED_CTRL_Z: '✅ Perfect! Am pus-o înapoi în buzunar (Ctrl+Z)',
        ERROR_ADDING: 'Hmm, buzunarul nu a putut să înghită asta... Încearcă din nou? 😅',
        ERROR_UPDATING: 'Buzunarul nu a reușit să organizeze schimbarea... Hai să reîncercăm!',
        ERROR_DELETING: 'Nu am putut scoate asta din buzunar. Încearcă din nou? 🤔',
        ERROR_RESTORING: 'Buzunarul are dificultăți să pună înapoi... Încearcă din nou?',
        TYPE_RECONCILED: 'Am ajustat tipul pe baza compartimentului ales 🎯',
        // Undo functionality cu personalitate Buzunar
        UNDO: {
            TITLE: 'Am scos din buzunar',
            BUTTON_TEXT: 'PUNE ÎNAPOI',
            NO_OPERATION: 'Nu există nimic de pus înapoi în buzunar',
            EXPIRED: 'Timpul a expirat pentru a pune înapoi (30s)',
            SUCCESS_TOAST: 'Înregistrarea e înapoi în buzunar!',
            SUCCESS_CTRL_Z: '✅ Perfect! Am pus-o înapoi în buzunar (Ctrl+Z)',
            ERROR: 'Nu am putut pune înapoi în buzunar...'
        }
    },
    CATEGORY: {
        ADDED: 'Categoria a fost adăugată',
        UPDATED: 'Categoria a fost actualizată',
        DELETED: 'Categoria a fost ștearsă',
        ERROR_ADDING: 'Eroare la adăugarea categoriei',
        ERROR_UPDATING: 'Eroare la actualizarea categoriei',
        ERROR_DELETING: 'Eroare la ștergerea categoriei'
    },
    EXPORT: {
        SUCCESS: 'Exportul a fost finalizat cu succes',
        ERROR: 'Eroare la exportul datelor'
    },
    AUTH: {
        LOGIN_SUCCESS: 'Autentificare reușită',
        LOGIN_ERROR: 'Eroare la autentificare',
        LOGOUT_SUCCESS: 'V-ați deconectat cu succes',
        REGISTER_SUCCESS: 'Contul a fost creat cu succes'
    },
    // Settings for toast behavior
    DURATION: {
        SHORT: 3000, // 3 secunde pentru mesaje simple
        MEDIUM: 5000, // 5 secunde pentru mesaje normale
        LONG: 7000, // 7 secunde pentru mesaje importante
        PERSISTENT: 0 // 0 = nu se închide automat
    }
};
// 🎯 POPOVER CONSTANTS - Pentru componenta Popover wrapper
export const POPOVER_CONSTANTS = {
    ARIA_LABELS: {
        CONTENT: 'Conținut popover',
        TRIGGER: 'Deschide popover',
        CLOSE: 'Închide popover'
    },
    POSITIONS: {
        TOP: 'top',
        RIGHT: 'right',
        BOTTOM: 'bottom',
        LEFT: 'left'
    },
    ALIGNMENTS: {
        START: 'start',
        CENTER: 'center',
        END: 'end'
    },
    DEFAULTS: {
        SIDE_OFFSET: 5,
        MAX_WIDTH: '320px',
        ANIMATION_DURATION: 200
    },
    // 🎯 TASK 12.2 - Constante pentru AdvancedEditPopover
    EDIT_TITLE: 'Editează tranzacția',
    ADD_TITLE: 'Adaugă tranzacție',
    AMOUNT_LABEL: 'Suma (RON)',
    DESCRIPTION_LABEL: 'Descriere',
    RECURRING_LABEL: 'Recurentă',
    FREQUENCY_LABEL: 'Frecvență',
    FREQUENCY_PLACEHOLDER: 'Selectează frecvența',
    FREQUENCY_MONTHLY: 'Lunar',
    FREQUENCY_WEEKLY: 'Săptămânal',
    FREQUENCY_YEARLY: 'Anual',
    DELETE_TOOLTIP: 'Șterge tranzacția',
    // 🔄 RECURRING FORM CONSTANTS - pentru AdvancedEditPopover
    RECURRING_SECTION_TITLE: 'Configurare Recurență',
    START_DATE_LABEL: 'Data de început',
    END_CONDITION_LABEL: 'Condiție de sfârșit',
    END_CONDITION_NONE: 'Fără sfârșit (indefinit)',
    END_CONDITION_OCCURRENCES: 'După un număr specific de repetări',
    END_CONDITION_UNTIL_DATE: 'Până la o dată specifică',
    OCCURRENCES_LABEL: 'Numărul de repetări',
    OCCURRENCES_PLACEHOLDER: 'Ex: 12',
    UNTIL_DATE_LABEL: 'Data de sfârșit'
};
export const TABLE = {
    HEADERS: {
        TYPE: 'Tip',
        AMOUNT: 'Sumă',
        CURRENCY: 'Monedă',
        CATEGORY: 'Categorie',
        SUBCATEGORY: 'Subcategorie',
        DATE: 'Dată',
        RECURRING: 'Recurent',
        FREQUENCY: 'Frecvență',
        DESCRIPTION: 'Descriere',
        RUNNING_BALANCE: 'Sold curent', // Pentru running balance column
        ACTIONS: 'Acțiuni', // Pentru actions column
    },
    EMPTY: EMPTY_STATE_MESSAGES.EMPTY_TRANSACTION_LIST,
    LOADING: LOADING_MESSAGES.GENERIC,
    LOADING_MORE: LOADING_MESSAGES.TRANSACTIONS,
    PAGE_INFO: 'Pagina {current} din {total}',
    SHOWING_INFO: 'Se afișează {shown} din {total} tranzacții',
    BOOL: {
        YES: 'Da',
        NO: 'Nu',
    },
    NO_TRANSACTIONS: EMPTY_STATE_MESSAGES.NO_TRANSACTIONS,
    NO_SUBCATEGORIES: EMPTY_STATE_MESSAGES.NO_SUBCATEGORIES,
    // 🚀 TASK 8.2 - Desktop-First Table Features
    ADVANCED_FEATURES: {
        // Pagination enhanced
        ITEMS_PER_PAGE: 'Elemente pe pagină:',
        JUMP_TO_PAGE: 'Mergi la pagina:',
        PAGE_SIZE_OPTIONS: 'Opțiuni mărime pagină',
        TOTAL_RECORDS: 'Total înregistrări: {count}',
        SELECTED_RECORDS: '{count} selectate',
        // Search and filtering
        SEARCH_PLACEHOLDER: 'Caută în tranzacții...',
        ADVANCED_SEARCH: 'Căutare avansată',
        REGEX_SEARCH: 'Căutare cu expresii regulate',
        CLEAR_FILTERS: 'Șterge filtrele',
        SAVE_FILTER_PRESET: 'Salvează preset filtru',
        LOAD_FILTER_PRESET: 'Încarcă preset filtru',
        // Sorting
        SORT_BY: 'Sortează după',
        SECONDARY_SORT: 'Sortare secundară',
        REMOVE_SORT: 'Elimină sortarea',
        MULTI_COLUMN_SORT_HINT: 'Ține Shift + Click pentru sortare pe mai multe coloane',
        // Selection and bulk operations
        SELECT_ALL: 'Selectează toate',
        SELECT_PAGE: 'Selectează pagina',
        DESELECT_ALL: 'Deselectează toate',
        BULK_ACTIONS: 'Acțiuni în masă',
        BULK_DELETE: 'Șterge selecțiile',
        BULK_EXPORT: 'Exportă selecțiile',
        BULK_EDIT_CATEGORY: 'Modifică categoria',
        // Export functionality
        EXPORT_OPTIONS: 'Opțiuni export',
        EXPORT_CSV: 'Exportă CSV',
        EXPORT_PDF: 'Exportă PDF',
        EXPORT_EXCEL: 'Exportă Excel',
        EXPORT_FILTERED: 'Exportă doar datele filtrate',
        EXPORT_ALL: 'Exportă toate datele',
        // Financial calculations
        RUNNING_BALANCE_SHOW: 'Afișează soldul curent',
        RUNNING_BALANCE_HIDE: 'Ascunde soldul curent',
        SUMMARY_FOOTER: 'Sumar financiar',
        TOTAL_INCOME: 'Total venituri',
        TOTAL_EXPENSES: 'Total cheltuieli',
        NET_BALANCE: 'Balanța netă',
        AVERAGE_TRANSACTION: 'Tranzacția medie',
        // Keyboard shortcuts
        KEYBOARD_SHORTCUTS: 'Comenzi rapide tastatură',
        NAVIGATION_HINT: 'Folosește săgețile pentru navigare',
        EDIT_HINT: 'Enter pentru editare, Escape pentru anulare',
        SEARCH_HINT: 'Ctrl+F pentru căutare rapidă',
        // Context menu
        CONTEXT_MENU: {
            EDIT: 'Editează tranzacția',
            DELETE: 'Șterge tranzacția',
            DUPLICATE: 'Duplică tranzacția',
            VIEW_DETAILS: 'Vezi detalii complete',
            ADD_TO_FAVORITES: 'Adaugă la favorite',
            COPY_VALUES: 'Copiază valorile',
        },
        // Desktop optimizations
        FULLSCREEN_MODE: 'Mod ecran complet',
        COMPACT_VIEW: 'Vizualizare compactă',
        COMFORTABLE_VIEW: 'Vizualizare confortabilă',
        COLUMN_VISIBILITY: 'Vizibilitate coloane',
        RESIZE_COLUMNS: 'Redimensionează coloanele',
        FREEZE_COLUMNS: 'Înghețe coloanele',
    },
};
// Texte pentru componenta de încărcare (Loader)
export const LOADER = {
    TEXT: LOADING_MESSAGES.GENERIC
};
// Texte pentru componenta ExcelGrid
export const EXCEL_GRID = {
    HEADERS: {
        LUNA: 'Luna',
        VENITURI: 'Venituri',
        CHELTUIELI: 'Cheltuieli',
        ECONOMII: 'Economii',
        SOLD: 'Sold',
        CATEGORII: 'Zilele Lunii',
        TOTAL: 'Total',
        ACTIUNI: 'Acțiuni',
        ZI: 'Zi',
        SUMA: 'Suma',
        TIP: 'Tip',
        DATA: 'Data',
        DESCRIERE: 'Descriere',
        RECURENT: 'Recurent',
        FRECVENTA: 'Frecvență'
    },
    // Numărul de zile pentru fiecare lună (ianuarie = index 0)
    DAYS_IN_MONTH: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    NO_DATA: EMPTY_STATE_MESSAGES.GENERIC,
    LOADING: LOADING_MESSAGES.DATA,
    PROMPTS: {
        ENTER_AMOUNT: 'Introduceți suma:',
        SELECT_CATEGORY: 'Selectați o categorie',
        SELECT_SUBCATEGORY: 'Selectați o subcategorie',
        SELECT_DAY: 'Selectați ziua',
        ENTER_DESCRIPTION: 'Introduceți o descriere (opțional)'
    },
    ACTIONS: {
        ADD_SUBCATEGORY: 'Adaugă subcategorie',
        EDIT_SUBCATEGORY: 'Editează subcategorie',
        DELETE_SUBCATEGORY: 'Șterge subcategorie',
        ADD_TRANSACTION: 'Adaugă tranzacție',
        EDIT_TRANSACTION: 'Editează tranzacție',
        DELETE_TRANSACTION: 'Șterge tranzacție',
        EXPAND_ALL: 'Extinde toate categoriile',
        COLLAPSE_ALL: 'Restrânge toate categoriile',
        SAVE_CHANGES: 'Salvează modificările',
        CANCEL: 'Anulează',
        CONFIRM: 'Confirmă'
    },
    // Constante pentru controalele tabelului TanStack
    TABLE_CONTROLS: {
        EXPAND_ALL: 'Extinde toate categoriile',
        COLLAPSE_ALL: 'Colapsează toate categoriile',
        VIRTUAL_TABLE: 'Tabel optimizat',
        LEGACY_TABLE: 'Tabel clasic',
        VERSION: 'Versiune'
    },
    // 🚨 TASK 5.4 - Constante noi pentru QuickAddModal
    MODAL: {
        // Labels pentru position mode
        FREQUENCY_SHORT: 'Frecv.',
        FINANCIAL_IMPACT_SHORT: 'Impact:',
        FINANCIAL_IMPACT_FULL: 'Impact financiar:',
        // Button text pentru position mode
        SAVE_SHORT: 'OK',
        // Loading și status messages
        SAVING_MESSAGE: LOADING_MESSAGES.SAVING_TRANSACTION,
        // ARIA labels pentru accessibility
        CLOSE_MODAL_ARIA: 'Închide modalul',
        // Confirmation dialog texte
        DELETE_CONFIRMATION_TITLE: 'Confirmați ștergerea tranzacției',
        DELETE_CONFIRMATION_MESSAGE: 'Sigur doriți să ștergeți această tranzacție? Acțiunea nu poate fi anulată.',
        DELETE_CONFIRM_BUTTON: 'Șterge',
        DELETE_CANCEL_BUTTON: 'Anulează'
    },
    // 🚨 TASK 5.4 - Error messages pentru modal operations
    ERROR_MESSAGES: {
        SAVE_TRANSACTION_GENERIC: 'Eroare la salvarea tranzacției. Încercați din nou.',
        SAVE_TRANSACTION_PREFIX: 'Eroare la salvarea tranzacției: ',
        DELETE_TRANSACTION_GENERIC: 'Eroare la ștergerea tranzacției. Încercați din nou.',
        DELETE_TRANSACTION_PREFIX: 'Eroare la ștergerea tranzacției: '
    },
    // Constante pentru inline editing system
    INLINE_EDITING: {
        EDIT_HINT: 'Apasă F2 pentru editare',
        SAVING: LOADING_MESSAGES.SAVING,
        // TASK 11: Timer delay pentru click detection (în ms)
        CLICK_DETECTION_DELAY: 250,
        VALIDATION_ERRORS: {
            EMPTY_VALUE: 'Valoarea nu poate fi goală',
            INVALID_NUMBER: 'Valoarea trebuie să fie un număr valid',
            NEGATIVE_VALUE: 'Valoarea nu poate fi negativă',
            INVALID_PERCENTAGE: 'Procentul trebuie să fie un număr valid',
            PERCENTAGE_RANGE: 'Procentul trebuie să fie între 0 și 100',
            INVALID_DATE: 'Data trebuie să fie în format valid',
            TEXT_TOO_LONG: 'Textul nu poate depăși 255 de caractere'
        },
        SAVE_ERROR: 'Eroare la salvare',
        PLACEHOLDER: {
            AMOUNT: 'Introduceți suma',
            TEXT: 'Introduceți textul',
            PERCENTAGE: 'Introduceți procentul',
            DATE: 'Introduceți data'
        }
    }
};
export const OPTIONS = {
    TYPE: [
        { value: TransactionType.INCOME, label: 'Venit' },
        { value: TransactionType.EXPENSE, label: 'Cheltuială' },
        { value: TransactionType.SAVING, label: 'Economisire' },
    ],
    CATEGORY: [
        { value: CategoryType.INCOME, label: 'Venituri' },
        { value: CategoryType.EXPENSE, label: 'Cheltuieli' },
        { value: CategoryType.SAVING, label: 'Economii' },
    ],
    FREQUENCY: [
        { value: FrequencyType.DAILY, label: 'Zilnic' },
        { value: FrequencyType.WEEKLY, label: 'Săptămânal' },
        { value: FrequencyType.MONTHLY, label: 'Lunar' },
        { value: FrequencyType.YEARLY, label: 'Anual' },
    ],
};
// Texte pentru pagina de opțiuni și gestionare categorii
export const UI = {
    OPTIONS_PAGE_TITLE: 'Opțiuni',
    CATEGORY_MANAGEMENT: 'Gestionare categorii',
    CATEGORY_MANAGEMENT_DESCRIPTION: 'Personalizați categoriile și subcategoriile pentru a se potrivi nevoilor dvs. specifice de bugetare.',
    MANAGE_CATEGORIES: 'Gestionare categorii',
    DISPLAY_OPTIONS: 'Opțiuni de afișare',
    DATA_EXPORT: 'Export date',
    ACCOUNT_SETTINGS: 'Setări Cont',
    ACCOUNT_LOGOUT_DESCRIPTION: 'Deconectează-te de la contul tău.',
    LOGOUT_BUTTON: 'Logout',
    COMING_SOON: 'În curând',
    LOGIN_REQUIRED: 'Trebuie să fiți autentificat pentru a accesa această pagină.',
    ADD_SUBCATEGORY: 'Adaugă subcategorie',
    DELETE_SUBCATEGORY: 'Șterge subcategorie',
    EDIT_SUBCATEGORY: 'Editează subcategorie',
    // Secțiune UI pentru CategoryEditor
    CATEGORY_EDITOR: {
        TITLE: 'Gestionare Subcategorii',
        CATEGORIES_SECTION_TITLE: 'Categorii',
        SUBCATEGORIES_SECTION_TITLE: 'Subcategorii pentru',
        CUSTOM_BADGE: 'custom',
        RENAME_BUTTON: 'Redenumește',
        DELETE_BUTTON: 'Șterge',
        ADD_PLACEHOLDER: 'Adaugă subcategorie nouă',
        ADD_BUTTON: 'Adaugă',
        NO_SELECTION: EMPTY_STATE_MESSAGES.NO_SELECTION,
        DELETE_CONFIRMATION_TITLE: 'Confirmare ștergere',
        DELETE_CONFIRMATION_TEXT: 'Ești sigur că vrei să ștergi subcategoria {subcat} din {cat}?',
        DELETE_WARNING: 'Atenție: Există {count} tranzacții care folosesc această subcategorie.',
        CONFIRM_DELETE_BUTTON: 'Confirmă ștergerea',
        CANCEL_BUTTON: 'Anulează'
    },
    FILTERS_ACTIVE: (count) => `${count} filtru${count === 1 ? '' : 'e'} activ${count === 1 ? '' : 'e'}`,
    // Secțiune UI pentru TransactionFilters
    TRANSACTION_FILTERS: {
        TITLE: 'Filtre',
        SHOW_ADVANCED: 'Filtre avansate',
        HIDE_ADVANCED: 'Ascunde filtre avansate',
        NO_FILTERS: EMPTY_STATE_MESSAGES.NO_FILTERS,
        DATE_RANGE: 'Interval date',
        AMOUNT_RANGE: 'Interval sume',
        TEXT_SEARCH: 'Căutare text',
    },
    // 🚨 AUDIT FIX - Adăugare titles hardcodate din LunarGrid
    SUBCATEGORY_ACTIONS: {
        DELETE_CUSTOM_TITLE: 'Șterge subcategoria custom',
        DELETE_ORPHAN_TITLE: 'Șterge tranzacțiile fără subcategorie (date murdare din trecut)',
        RENAME_TITLE: 'Redenumește subcategoria',
    },
    LUNAR_GRID_TOOLTIPS: {
        CALCULATED_SUM: 'Suma calculată automată din subcategorii',
        DAILY_BALANCES: 'Balanțe zilnice',
    },
    // 🚨 AUDIT FIX - Texte pentru LunarGridPage
    LUNAR_GRID_PAGE: {
        FULLSCREEN_EXIT_HINT: 'Press ESC pentru a ieși din fullscreen',
        NAVIGATION_LOADING: LOADING_MESSAGES.NAVIGATION,
        LOADING_MESSAGE_TEMPLATE: LOADING_MESSAGES.DATE_CONTEXT,
        // Mobile overlay pentru feature disponibil doar pe desktop
        MOBILE_OVERLAY: {
            TITLE: '📱 Feature Disponibil pe Desktop',
            MESSAGE: 'Grid-ul Lunar este un feature avansat optimizat pentru desktop și tabletă. Pentru cea mai bună experiență, te rugăm să accesezi aplicația pe un dispozitiv cu ecran mai mare.',
            SUBTITLE: 'De ce pe desktop?',
            REASONS: [
                '• Vizualizare completă a calendarul lunar',
                '• Editare facilă cu mouse și tastatură',
                '• Vedere detalională a categoriilor',
                '• Performanță optimizată pentru date complexe'
            ],
            BUTTON_TEXT: 'Înțeleg',
            ALTERNATIVE: 'În schimb, poți folosi pagina de Tranzacții pentru gestionare pe mobil.'
        },
        LAYOUT_MODES: {
            FULL_WIDTH: 'Lățime completă',
            FULLSCREEN: 'Fullscreen',
        },
        LAYOUT_TOGGLE_TOOLTIP: 'Comută la modul următor ({nextMode})',
        MONTHS: {
            IANUARIE: 'Ianuarie',
            FEBRUARIE: 'Februarie',
            MARTIE: 'Martie',
            APRILIE: 'Aprilie',
            MAI: 'Mai',
            IUNIE: 'Iunie',
            IULIE: 'Iulie',
            AUGUST: 'August',
            SEPTEMBRIE: 'Septembrie',
            OCTOMBRIE: 'Octombrie',
            NOIEMBRIE: 'Noiembrie',
            DECEMBRIE: 'Decembrie'
        }
    },
};
// Flag pentru subcategoriile custom
export const FLAGS = {
    CUSTOM: 'custom',
};
// Mesaj informativ pentru starea goală a editorului de categorii
export const INFO = {
    CATEGORY_EDITOR_EMPTY: EMPTY_STATE_MESSAGES.NO_SELECTION,
    NO_TRANSACTIONS: EMPTY_STATE_MESSAGES.NO_TRANSACTIONS,
    NO_SUBCATEGORIES: EMPTY_STATE_MESSAGES.NO_SUBCATEGORIES,
};
// Constante pentru LunarGrid
export const LUNAR_GRID = {
    COLLAPSE_ALL: 'Restrânge',
    EXPAND_ALL: 'Extinde',
    RESET_EXPANSION: 'Reset',
    // Versiuni scurte pentru ecrane mici
    COLLAPSE_SHORT: 'Restrânge',
    EXPAND_SHORT: 'Extinde',
    RESET_SHORT: 'Reset',
    LOADING: LOADING_MESSAGES.DATA,
    NO_DATA: EMPTY_STATE_MESSAGES.GENERIC,
    // 🚨 DUPLICATE FIX - Folosesc BALANCE_LABELS.SOLD în loc de string hardcodat
    get TOTAL_BALANCE() { return BALANCE_LABELS.SOLD; },
    // Constante pentru controale individuale
    EXPAND_CATEGORY: 'Extinde',
    COLLAPSE_CATEGORY: 'Restrânge',
    EXPAND_CATEGORY_TITLE: 'Extinde categoria',
    COLLAPSE_CATEGORY_TITLE: 'Restrânge categoria',
    // Constante pentru scroll UX
    SCROLL_HINT: 'Scroll pentru a vedea mai multe date',
    STICKY_HEADER_ACTIVE: 'Header fix activ',
    // Constante pentru redimensionare tabel
    RESIZE: {
        TOGGLE_FULLSCREEN: 'Comută fullscreen',
        EXIT_FULLSCREEN: 'Ieși din fullscreen',
        RESIZE_BUTTON_TITLE: 'Redimensionează tabelul',
        FULLSCREEN_MODE: 'Mod fullscreen activ',
        NORMAL_MODE: 'Mod normal',
        RESET_COLUMNS: 'Resetează coloane',
        RESET_COLUMNS_SHORT: 'Coloane'
    }
};
export const BALANCE_SYSTEM = {
    INITIAL_BALANCE: "Sold Inițial",
    DAILY_BALANCE: "Sold Zilnic",
    STARTING_DATE: "Data de început",
    ACCOUNT_NAME: "Nume Cont",
    ADD_ACCOUNT: "Adaugă Cont",
    TOTAL_BALANCE: "Sold Total",
    BALANCE_WARNING: "Avertisment Sold",
    CONFIGURE_BALANCE: "Configurează Sold",
    NEGATIVE_BALANCE_ALERT: "Alertă Sold Negativ",
    // Date configuration
    BALANCE_START_DATE: "Data de început pentru calculul soldului",
    BALANCE_START_DATE_HELP: "Alege data de la care să înceapă calculul soldurilor",
    BALANCE_START_DATE_PLACEHOLDER: "Selectează data...",
    BALANCE_START_INDICATOR: "Start",
    BALANCE_START_TOOLTIP: "Calculul soldurilor începe de aici",
    MONTHLY_TRANSFERS: "Transfer automat între luni",
    MONTHLY_TRANSFERS_HELP: "Soldul din luna anterioară va fi transferat automat",
};
export const BALANCE_WARNINGS = {
    NEGATIVE_BALANCE: "Atenție: Sold negativ!",
    LOW_BALANCE: "Atenție: Sold scăzut!",
    CHECK_TRANSACTIONS: "Verifică tranzacțiile.",
};
export const MONTHLY_BALANCE = {
    SETUP_TITLE: "Configurare Sold Luna",
    START_DATE: "Data începere planificare",
    INITIAL_BALANCE: "Sold inițial",
    AUTO_TRANSFER: "Transfer automat din luna anterioară",
    CONFIRM_SETUP: "Confirmă configurarea",
    DAILY_BALANCE_ROW: "Sold disponibil",
};
// Constante pentru teste - eliminate strings hardcodate
export const TEST_CONSTANTS = {
    ALERTS: {
        TEST_MESSAGE: 'Acesta este un mesaj de alertă',
        ERROR_MESSAGE: 'Eroare de procesare',
        SUCCESS_MESSAGE: 'Operație reușită',
        WARNING_MESSAGE: 'Atenție la acțiune',
        INFO_MESSAGE: 'Informație importantă',
        CUSTOM_CLASS_MESSAGE: 'Test clasă personalizată',
        BASE_CLASS_MESSAGE: 'Test clase de bază'
    },
    SELECT: {
        PLACEHOLDER: 'Alege o opțiune',
        OPTION_1: 'Opțiunea 1',
        OPTION_2: 'Opțiunea 2',
        OPTION_3: 'Opțiunea 3',
        LABEL: 'Selecție',
        REQUIRED_ERROR: 'Acest câmp este obligatoriu'
    },
    TEXTAREA: {
        PLACEHOLDER: 'Comentariile tale',
        REQUIRED_ERROR: 'Acest câmp este obligatoriu',
        LABEL: 'Textarea test',
        TEST_VALUE: 'Acesta este un text de test'
    },
    CHECKBOX: {
        LABEL: 'Acceptă termenii',
        REQUIRED_ERROR: 'Trebuie să acceptați termenii',
        CHECKED_LABEL: 'Opțiune bifată'
    },
    COMMON: {
        TEST_MESSAGE: 'Mesaj de test',
        LOADING: 'Se încarcă...',
        ERROR_GENERIC: 'Eroare'
    }
};
// 🚨 AUDIT FIX - Constante suplimentare pentru LunarGrid
export const LUNAR_GRID_ACTIONS = {
    NO_TRANSACTIONS: 'fără tranzacții',
    ENTER_KEY: 'Enter',
    ESCAPE_KEY: 'Escape',
    // 🎯 LGI-TASK-06: Mesaje pentru keyboard deletion
    DELETE_TRANSACTION_SINGLE: 'Ștergi această tranzacție definitiv?',
    DELETE_TRANSACTION_MULTIPLE: 'Ștergi {count} tranzacții definitiv?',
    DELETE_SUCCESS_SINGLE: 'Tranzacție ștearsă cu succes',
    DELETE_SUCCESS_MULTIPLE: '{count} tranzacții șterse cu succes',
    DELETE_ALL_BUTTON: 'Șterge toate',
    DELETE_ERROR: 'Eroare la ștergerea tranzacțiilor',
    NO_TRANSACTIONS_TO_DELETE: 'Nu există tranzacții de șters pentru pozițiile selectate',
    DELETE_DISABLED_MULTIPLE: 'Nu poți folosi Delete când celula conține mai multe tranzacții. Folosește popover-ul pentru a șterge individual.',
    DELETE_ALL_CONFIRM: 'Ștergi toate cele {count} tranzacții din această celulă?',
    DELETE_ALL_SUCCESS: '{count} tranzacții șterse cu succes',
    // 🆕 TASK 7.4 - Bulk delete loading & undo
    DELETE_ALL_LOADING: 'Se șterg {count} tranzacții...',
    UNDO_BULK_DELETE_TITLE: '{count} tranzacții șterse – Anulează?',
    UNDO_BULK_DELETE_SUCCESS: 'Ștergerea a fost anulată',
    UNDO_BULK_DELETE_ERROR: 'Eroare la restaurarea tranzacțiilor șterse',
};
// 🆕 Account Management Constants - pentru sistem conturi multiple
export const ACCOUNT_MANAGEMENT = {
    TITLE: "Gestionare Conturi",
    ADD_ACCOUNT: "Adaugă Cont Nou",
    EDIT_ACCOUNT: "Editează Cont",
    DELETE_ACCOUNT: "Șterge Cont",
    SAVE_ACCOUNT: "Salvează cont",
    ADD_NEW_ACCOUNT: "Adaugă cont nou",
    ACCOUNT_TYPES: {
        BANK: "Cont bancar",
        CASH: "Numerar",
        INVESTMENT: "Investiții",
        OTHER: "Altele",
    },
    TOTAL_BALANCE: "Total sold disponibil",
    MAX_ACCOUNTS_REACHED: "Maxim 10 conturi permise",
    MAX_ACCOUNTS: 10, // Existing property, preserved
    PLACEHOLDERS: {
        ACCOUNT_NAME: "Nume cont (ex: Cont Curent BRD)",
    },
    // UI Labels - Preserved
    LABELS: {
        ACCOUNT_NAME: 'Nume cont',
        ACCOUNT_TYPE: 'Tip cont',
        INITIAL_BALANCE: 'Sold inițial',
        CURRENT_BALANCE: 'Sold curent',
        ACCOUNT_DESCRIPTION: 'Descriere cont',
        DEFAULT_ACCOUNT: 'Cont principal',
        ACTIVE_STATUS: 'Activ',
        MONTHLY_TRANSFER: 'Transfer automat între luni',
        OTHER_INCOME: 'Alte venituri',
        INCLUDED_IN_TOTAL: 'Inclus în total balance',
        EXCLUDED_FROM_TOTAL: 'Exclus din total balance',
        STATUS_INCLUDED: 'Inclus',
        STATUS_EXCLUDED: 'Exclus',
        UNSAVED_CHANGES: 'modificări nesalvate',
        NEW_ACCOUNT_INCLUDED: 'Noul cont va fi inclus în total balance',
    },
    // Validation Messages - Preserved, with MAX_ACCOUNTS_REACHED handled at top level
    VALIDATION: {
        NAME_REQUIRED: 'Numele contului este obligatoriu',
        NAME_TOO_LONG: 'Numele contului nu poate depăși 50 de caractere',
        TYPE_REQUIRED: 'Tipul contului este obligatoriu',
        INITIAL_BALANCE_REQUIRED: 'Soldul inițial este obligatoriu',
        INITIAL_BALANCE_INVALID: 'Soldul inițial trebuie să fie un număr valid',
        // MAX_ACCOUNTS_REACHED: `Nu puteți avea mai mult de ${10} conturi`, // This is now a top-level property
        DUPLICATE_NAME: 'Există deja un cont cu acest nume',
        CANNOT_DELETE_LAST: 'Nu puteți șterge ultimul cont activ',
        CANNOT_DELETE_WITH_TRANSACTIONS: 'Nu puteți șterge un cont care are tranzacții',
    },
    // Action Messages - Preserved, with top-level properties taking precedence
    ACTIONS: {
        // ADD_ACCOUNT: 'Adaugă cont nou', // Now top-level
        // EDIT_ACCOUNT: 'Editează cont', // Now top-level
        // DELETE_ACCOUNT: 'Șterge cont', // Now top-level
        SET_DEFAULT: 'Setează ca principal',
        ACTIVATE_ACCOUNT: 'Activează cont',
        DEACTIVATE_ACCOUNT: 'Dezactivează cont',
    },
    // Status Messages - Preserved
    STATUS: {
        ACCOUNT_CREATED: 'Cont creat cu succes',
        ACCOUNT_UPDATED: 'Cont actualizat cu succes',
        ACCOUNT_DELETED: 'Cont șters cu succes',
        ACCOUNT_SET_DEFAULT: 'Cont setat ca principal',
    },
    // Modal și dialog texts
    MODALS: {
        PRE_START_TITLE: 'Tranzacții anterioare',
        PRE_START_MESSAGE: (count, total, type) => `Există ${count} tranzacții înainte de luna selectată (sold total: ${total}${type}). Cum dorești să le tratăm?`,
        PRE_START_EXPENSE: ' cheltuieli',
        PRE_START_INCOME: ' venit',
        PRE_START_ADD_TO_BALANCE: 'Adaugă la sold',
        PRE_START_IGNORE: 'Ignoră tranzacțiile',
        PRE_START_DELETE: 'Șterge tranzacțiile',
        CONFIRM_MONTH_CHANGE_TITLE: 'Confirmare schimbare lună de început',
        CONFIRM_ACTION: 'Confirmă',
    },
    TOASTS: {
        INCLUDED_IN_TOTAL: (name, included) => `Contul "${name}" a fost ${included ? 'inclus în' : 'exclus din'} total.`,
        UPDATE_SUCCESS: 'Nume cont actualizat cu succes!',
        BALANCE_UPDATE_SUCCESS: 'Sold cont actualizat cu succes!',
        ADD_SUCCESS: 'Cont adăugat cu succes!',
        DELETE_SUCCESS: (name) => `Contul "${name}" a fost șters.`,
        START_DATE_SUCCESS: 'Data de început salvată!',
        START_DATE_REQUIRED: 'Data de început este obligatorie.',
        INVALID_VALUE: 'Valoarea trebuie să fie un număr valid.',
        CHANGES_SAVED: 'Modificările au fost salvate cu succes!',
        SAVE_ERROR: 'Eroare la salvarea modificărilor',
        CHANGES_CANCELLED: 'Modificările au fost anulate',
        PRE_START_IGNORE: 'Tranzacțiile anterioare vor fi ignorate.',
        PRE_START_DELETE: 'Tranzacțiile anterioare au fost șterse.',
    },
    // 🪙 BUZUNARUL - Icon Labels pentru tipuri de conturi
    ICON_LABELS: {
        BANK: 'Bancă',
        CASH: 'Cash',
        SAVINGS: 'Economii',
        INVESTMENT: 'Investiții',
        CRYPTO: 'Crypto',
        CREDIT_CARD: 'Card credit',
        LOAN: 'Împrumut',
        OTHER: 'Alte venituri',
    },
};
// 🆕 Balance Display Constants - pentru afișarea soldului și calculări
export const BALANCE_DISPLAY = {
    // Formatting Rules
    CURRENCY: 'RON',
    DECIMAL_PLACES: 2,
    THOUSAND_SEPARATOR: '.',
    DECIMAL_SEPARATOR: ',',
    // Labels
    LABELS: {
        AVAILABLE_BALANCE: 'Sold disponibil',
        SAVINGS_BALANCE: 'Sold economii',
        TOTAL_BALANCE: 'Sold total',
        PROJECTED_BALANCE: 'Sold proiectat',
        DAILY_BALANCE: 'Sold zilnic',
        FINAL_BALANCE: 'Sold sfârșit lună',
        REMAINING_TOTAL: 'Total Sold Rămas',
        BALANCE_CHANGE: 'Schimbare sold',
        BALANCE_TREND: 'Tendință sold',
    },
    // Colors pentru Transaction Types (CSS classes pentru TailwindCSS)
    COLORS: {
        INCOME: 'text-green-600 bg-green-50 border-green-200', // Verde pentru venituri
        EXPENSE: 'text-red-600 bg-red-50 border-red-200', // Roșu pentru cheltuieli
        SAVING: 'text-blue-600 bg-blue-50 border-blue-200', // Albastru pentru economii/investiții
        POSITIVE: 'text-green-600', // Pentru solduri pozitive
        NEGATIVE: 'text-red-600', // Pentru solduri negative
        NEUTRAL: 'text-gray-600', // Pentru solduri zero/neutrale
        WARNING: 'text-yellow-600', // Pentru solduri apropiate de zero
    },
    // Praguri pentru diverse stări de sold
    THRESHOLDS: {
        /** Prag (absolut) sub care soldul este considerat "aproape de zero" și se afișează în galben */
        NEAR_ZERO: 500,
    },
    // Grid Styles pentru balance rows
    GRID_STYLES: {
        BALANCE_ROW: 'font-semibold bg-gray-50',
        BALANCE_CELL: 'text-center font-mono text-sm',
        BALANCE_TOTAL: 'border-t-2 border-gray-300 font-bold',
        BALANCE_PROJECTION: 'bg-blue-50 border-blue-200',
    },
    // Status indicators
    STATUS: {
        CALCULATED: 'Calculat automat',
        MANUAL_OVERRIDE: 'Suprascris manual',
        PROJECTED: 'Valoare proiectată',
        CONFIRMED: 'Confirmat',
    },
    // Tooltips detaliate pentru explicații suplimentare
    TOOLTIPS: {
        /** Tooltip pentru coloana Total Sold Rămas – explică ce reprezintă suma. */
        REMAINING_TOTAL: 'Totalul soldului rămas la sfârșitul lunii,\ndupă ce au fost contabilizate toate tranzacțiile și transferurile.',
        /** Tooltip pentru ziua de start a calculului soldurilor */
        START_DAY: 'Calculul soldurilor începe de aici',
        /** Tooltip pentru categorii - suma calculată automat */
        CALCULATED_SUM: 'Suma calculată automată din subcategorii',
        /** Tooltip pentru butonul de expand/collapse categorie */
        EXPAND_CATEGORY: 'Extinde categoria pentru a vedea subcategoriile',
        COLLAPSE_CATEGORY: 'Restrânge categoria',
        /** Tooltip pentru butonul de redenumire subcategorie */
        RENAME_SUBCATEGORY: 'Redenumește subcategoria',
        /** Tooltip pentru butonul de ștergere subcategorie custom */
        DELETE_SUBCATEGORY: 'Șterge subcategoria custom',
        /** Tooltip pentru butonul de fullscreen */
        TOGGLE_FULLSCREEN: 'Comută modul fullscreen',
        /** Tooltip pentru celulele editabile */
        EDITABLE_CELL: 'Dublu-click pentru editare',
        /** Tooltip pentru butonul de adăugare tranzacții multiple */
        ADD_MULTIPLE: 'Adaugă mai multe tranzacții',
        /** Tooltip pentru butonul de salvare */
        SAVE_EDIT: 'Salvează (Enter)',
        /** Tooltip pentru butonul de anulare */
        CANCEL_EDIT: 'Anulează (Escape)',
        /** Tooltip pentru butonul de editare inline */
        EDIT_INLINE: 'Editează inline (F2 sau Enter)',
        /** Tooltip pentru butonul de ștergere tranzacție */
        DELETE_TRANSACTION: 'Șterge tranzacția',
        /** Tooltip pentru butonul Done în adăugare subcategorie */
        DONE_ADD_SUBCATEGORY: 'Finalizează adăugarea subcategoriei',
        /** Tooltip pentru butonul Cancel în adăugare subcategorie */
        CANCEL_ADD_SUBCATEGORY: 'Anulează adăugarea subcategoriei',
        /** Tooltip pentru butonul de editare tranzacție în popover */
        EDIT_TRANSACTION: 'Editează tranzacția',
        /** Tooltip pentru tranzacțiile recurente */
        RECURRING_TRANSACTION: (frequency) => `Recurent${frequency ? ` - ${frequency}` : ''}`,
    },
};
// 🆕 Modal Variants pentru balance system
export const BALANCE_MODALS = {
    // Account Management Modals
    ACCOUNT: {
        CREATE_TITLE: 'Adaugă cont nou',
        EDIT_TITLE: 'Editează cont',
        DELETE_TITLE: 'Șterge cont',
        TRANSFER_TITLE: 'Transfer între conturi',
    },
    // Balance Adjustment Modals
    BALANCE: {
        ADJUST_TITLE: 'Ajustează sold',
        RECONCILE_TITLE: 'Reconciliere sold',
        PROJECTION_TITLE: 'Proiecție sold',
        HISTORY_TITLE: 'Istoric sold',
    },
    // Confirmation Messages
    CONFIRMATIONS: {
        DELETE_ACCOUNT: 'Ștergeți contul și toate datele asociate?',
        ADJUST_BALANCE: 'Confirmați ajustarea soldului?',
        TRANSFER_FUNDS: 'Confirmați transferul de fonduri?',
        RECONCILE: 'Confirmați reconcilierea soldului?',
    },
};
// 🚨 DUPLICATE FIX - Consolidez SOLD related constants
export const BALANCE_LABELS = {
    SOLD: 'Sold', // ✅ Consolidat din LABELS.SOLD (linia 113)
    TOTAL_BALANCE: 'Sold total', // ✅ Înlocuiește LUNAR_GRID.TOTAL_BALANCE (linia 331)
    DAILY_BALANCES: 'Balanțe zilnice', // ✅ Existent deja în UI
    BALANCE: 'Balanță',
    AVAILABLE: 'Disponibil',
    SAVINGS: 'Economii',
    INVESTMENTS: 'Investiții',
};
// Texte pentru componenta Export Modal
export const EXPORT_UI = {
    YEAR_LABEL: 'An:',
    MONTH_LABEL: 'Lună:',
    CATEGORY_FILTER_LABEL: 'Categorie:',
    FILENAME_LABEL: 'Numele fișierului:',
    FILENAME_PLACEHOLDER: 'ex: raport-lunar',
    REPORT_TITLE_LABEL: 'Titlu raport (opțional)',
    REPORT_TITLE_PLACEHOLDER: 'Ex: Raport financiar ianuarie 2025'
};
// Supporting UI Components
export const TOOLTIP = {
    DEFAULT_DELAY: 200,
    PLACEMENTS: {
        TOP: 'Sus',
        BOTTOM: 'Jos',
        LEFT: 'Stânga',
        RIGHT: 'Dreapta'
    },
    VARIANTS: {
        DEFAULT: 'Implicit',
        INFO: 'Informație',
        WARNING: 'Avertisment',
        ERROR: 'Eroare',
        SUCCESS: 'Succes'
    }
};
export const PROGRESS = {
    LABELS: {
        BUDGET_PROGRESS: 'Progres Buget',
        EXPORT_PROGRESS: 'Progres Export',
        LOADING_PROGRESS: 'Se încarcă...',
        FINANCIAL_GOAL: 'Obiectiv Financiar'
    },
    VARIANTS: {
        DEFAULT: 'Implicit',
        SUCCESS: 'Succes',
        WARNING: 'Avertisment',
        ERROR: 'Eroare',
        FINANCIAL: 'Financiar'
    },
    SIZES: {
        SMALL: 'Mic',
        MEDIUM: 'Mediu',
        LARGE: 'Mare',
        EXTRA_LARGE: 'Extra Mare'
    },
    POSITIONS: {
        TOP: 'Sus',
        BOTTOM: 'Jos',
        INLINE: 'În linie'
    }
};
export const BADGE = {
    VARIANTS: {
        NEUTRAL: 'Neutru',
        PRIMARY: 'Principal',
        SUCCESS: 'Succes',
        WARNING: 'Avertisment',
        ERROR: 'Eroare',
        INFO: 'Informație'
    },
    FINANCIAL_STATES: {
        OVER_BUDGET: 'Peste Buget',
        UNDER_BUDGET: 'Sub Buget',
        ON_TARGET: 'Pe Țintă',
        INCOME: 'Venit',
        EXPENSE: 'Cheltuială'
    }
};
// 🧭 Navigation System Constants
export const NAVIGATION = {
    // Main navigation items
    ITEMS: {
        DASHBOARD: 'Tablou de bord',
        TRANSACTIONS: 'Tranzacții',
        LUNAR_GRID: 'Grid Lunar',
        ACCOUNTS: 'Conturi',
        REPORTS: 'Rapoarte',
        OPTIONS: 'Opțiuni',
        SETTINGS: 'Setări'
    },
    // Sidebar specific
    SIDEBAR: {
        TOGGLE: 'Comută sidebar',
        EXPAND: 'Extinde sidebar',
        COLLAPSE: 'Restrânge sidebar',
        PERSISTENT: 'Sidebar persistent',
        AUTO_HIDE: 'Ascunde automat'
    },
    // Breadcrumbs
    BREADCRUMBS: {
        HOME: 'Acasă',
        SEPARATOR: '/',
        BACK_TO: 'Înapoi la',
        CURRENT_PAGE: 'Pagina curentă'
    },
    // Context menu
    CONTEXT_MENU: {
        OPEN: 'Deschide meniu contextual',
        CLOSE: 'Închide meniu contextual',
        NEW_TAB: 'Deschide în tab nou',
        BOOKMARK: 'Adaugă la favorite',
        SHARE: 'Partajează'
    },
    // Tabs system
    TABS: {
        NEW_TAB: 'Tab nou',
        CLOSE_TAB: 'Închide tab',
        CLOSE_ALL: 'Închide toate',
        CLOSE_OTHERS: 'Închide celelalte',
        NEXT_TAB: 'Tab următor',
        PREV_TAB: 'Tab anterior'
    },
    // Keyboard shortcuts
    SHORTCUTS: {
        TOGGLE_SIDEBAR: 'Ctrl+\\',
        NEW_TAB: 'Ctrl+T',
        CLOSE_TAB: 'Ctrl+W',
        NEXT_TAB: 'Ctrl+Tab',
        PREV_TAB: 'Ctrl+Shift+Tab',
        CONTEXT_MENU: 'Shift+F10',
        HOME: 'Alt+H',
        BACK: 'Alt+Săgeată stânga',
        FORWARD: 'Alt+Săgeată dreapta',
        COMMAND_PALETTE: 'Ctrl+K',
        TOGGLE_DARK_MODE: 'Ctrl+D'
    },
    // Command Palette system
    COMMAND_PALETTE: {
        TITLE: 'Comandă rapidă',
        PLACEHOLDER: 'Caută acțiuni, pagini, shortcuts...',
        NO_RESULTS: 'Niciun rezultat găsit',
        HELP_TEXT: 'Apasă Escape pentru a închide',
        CATEGORIES: {
            NAVIGATION: 'Navigare',
            ACTIONS: 'Acțiuni',
            SHORTCUTS: 'Comenzi rapide',
            RECENT: 'Recent'
        },
        DESCRIPTIONS: {
            LUNAR_GRID: 'Grid lunar pentru planificare financiară',
        },
        RESULTS: {
            GO_TO: 'Mergi la',
            EXECUTE: 'Execută',
            OPEN: 'Deschide',
            TOGGLE: 'Comută'
        }
    },
    // Theme System Constants
    THEME: {
        TOGGLE_DARK_MODE: 'Comută tema întunecată',
        DARK_MODE: 'Tema întunecată',
        LIGHT_MODE: 'Tema deschisă',
        SYSTEM_PREFERENCE: 'Preferința sistemului',
        TOGGLE_DESCRIPTION: 'Comută între tema deschisă și întunecată'
    },
    // Mobile navigation
    MOBILE: {
        HAMBURGER: 'Deschide meniul principal',
        CLOSE_MENU: 'Închide meniul',
        MENU_OVERLAY: 'Overlay meniu mobil'
    },
    // Accessibility
    ARIA: {
        NAVIGATION: 'Navigare principală',
        BREADCRUMB: 'Navigare breadcrumb',
        TAB_LIST: 'Listă taburi',
        TAB_PANEL: 'Panou tab',
        CURRENT_PAGE: 'Pagina curentă',
        EXTERNAL_LINK: 'Deschide în fereastră nouă',
        CONTEXT_MENU: 'Meniu contextual'
    },
    // Persistence storage keys
    STORAGE: {
        SIDEBAR_EXPANDED: 'sidebar-expanded',
        TABS_STATE: 'app-tabs-state',
        BREADCRUMB_HISTORY: 'navigation-breadcrumb-history',
        NAVIGATION_STATE: 'navigation-global-state',
        LAST_VISITED_PAGE: 'navigation-last-page',
        USER_PREFERENCES: 'navigation-user-preferences'
    },
    // State management
    STATE: {
        PERSISTENCE_ENABLED: 'Persistența navigării activată',
        PERSISTENCE_DISABLED: 'Persistența navigării dezactivată',
        STATE_RESTORED: 'Starea navigării a fost restaurată',
        STATE_CLEARED: 'Starea navigării a fost ștearsă',
        SYNC_COMPLETE: 'Sincronizarea componentelor completă',
        SYNC_FAILED: 'Eșec la sincronizarea componentelor'
    }
};
// Breadcrumb Text
export const BREADCRUMB_HOME = "Acasă";
export const BREADCRUMB_SEPARATOR = "/";
// LunarGrid Preferences
export const LUNAR_GRID_PREFERENCES_TITLE = "🗓️ Preferințe LunarGrid";
export const LUNAR_GRID_DELETE_CONFIRM_TITLE = "⌨️ Confirmare ștergere cu Delete key";
export const LUNAR_GRID_DELETE_CONFIRM_DESCRIPTION = "Controlează dacă aplicația va cere confirmare când ștergi tranzacții folosind tasta Delete în grid.";
export const LUNAR_GRID_DELETE_CONFIRM_LABEL = "Afișează confirmare pentru ștergere cu Delete key";
export const LUNAR_GRID_DELETE_CONFIRM_RECOMMENDATION = "💡 Recomandat activat pentru a preveni ștergerea accidentală a tranzacțiilor importante. Când e dezactivat, Delete key va șterge imediat fără confirmare (stil Excel cu Undo).";
export const LUNAR_GRID_DELETE_CONFIRM_ENABLED_SUCCESS = "Confirmarea pentru ștergere a fost activată";
export const LUNAR_GRID_DELETE_CONFIRM_DISABLED_SUCCESS = "Confirmarea pentru ștergere a fost dezactivată";
// FUTURE UI CONSTANTS - exemplu pentru extensibilitate:
// LUNAR_GRID_AUTO_SAVE_TITLE: "Auto-save delay",
// LUNAR_GRID_AUTO_SAVE_DESCRIPTION: "Controlează întârzierea pentru salvarea automată.",
// LUNAR_GRID_GRID_LINES_TITLE: "📏 Afișare linii grid",
// LUNAR_GRID_COMPACT_MODE_TITLE: "📦 Mod compact",
// LUNAR_GRID_SHORTCUTS_TITLE: "⌨️ Keyboard shortcuts",
// 🎯 TASK 13 - EXPORT FORMAT OPTIONS
export const EXPORT_FORMATS = [
    { value: "csv", label: "CSV (Comma Separated)" },
    { value: "excel", label: "Excel (XLSX)" },
    { value: "json", label: "JSON (Pentru dezvoltatori)" },
];
// 🎯 TASK 13 - EXPORT STATUS MESSAGES
export const EXPORT_STATUS = {
    WILL_EXPORT_COUNT: (count) => `Se vor exporta ${count} tranzacții.`,
    SAVE_ERROR: 'Eroare la salvare',
    DELETE_ERROR: 'Eroare la ștergere',
    DELETE_CONFIRM_TITLE: 'Șterge tranzacția',
};
export const POPOVER_EXAMPLES = {
    EDIT_VALUE_TITLE: "Editează valoarea",
    EDIT_BUTTON: "Editează",
    INFO_TITLE: "Informații utile",
    INFO_MESSAGE: "Acest buton oferă informații suplimentare despre funcționalitatea curentă.",
    DUPLICATE_BUTTON: "Duplică",
    SETTINGS_BUTTON: "Setări",
};
export const OPTIONS_PAGE = {
    RESET_SUBCATEGORIES_CONFIRMATION: {
        TITLE_DELETE: "⚠️ Resetare Subcategorii + Ștergere Tranzacții",
        TITLE_NO_DELETE: "🔄 Resetare Subcategorii",
        MESSAGE_START: "Resetarea subcategoriilor va face următoarele:\n\n",
        MESSAGE_DELETE_CUSTOM: (count) => `🗑️ Va șterge ${count} subcategorii custom:\n`,
        MESSAGE_AND_MORE: (count) => `\n• ... și încă ${count} subcategorii`,
        MESSAGE_RENAME_MODIFIED: (count) => `🔄 Va redenumi ${count} subcategorii modificate la numele inițiale\n\n`,
        MESSAGE_DELETE_TRANSACTIONS: (count) => `⚠️ Va șterge ${count} tranzacții de pe subcategoriile custom:\n`,
        MESSAGE_AND_MORE_TRANSACTIONS: `\n• ... și alte subcategorii`,
        MESSAGE_NO_DELETE: "✅ Nu vor fi șterse tranzacții (nu există tranzacții pe subcategorii custom)",
        DETAILS_DELETE_CUSTOM: (count) => `${count} subcategorii custom vor fi șterse`,
        DETAILS_RENAME_MODIFIED: (count) => `${count} subcategorii vor fi redenumite`,
        DETAILS_DELETE_TRANSACTIONS: (count) => `${count} tranzacții vor fi șterse definitiv`,
        DETAILS_NO_DELETE: "0 tranzacții vor fi șterse",
        RECOMMENDATION_DELETE: "Înainte de reset, mergeți în LunarGrid și mutați manual tranzacțiile importante pe subcategorii pe care doriți să le păstrați.",
        RECOMMENDATION_NO_DELETE: "Subcategoriile custom vor fi șterse și cele modificate vor fi redenumite la valorile inițiale.",
        CONFIRM_DELETE: "Resetează și șterge tranzacțiile",
        CONFIRM_NO_DELETE: "Resetează subcategoriile",
        TOAST_CANCEL_DELETE: "Resetarea anulată. Mutați tranzacțiile manual din LunarGrid înainte de reset.",
        TOAST_CANCEL_NO_DELETE: "Resetarea anulată.",
    },
    FINAL_CONFIRMATION: {
        TITLE: "Confirmarea finală pentru ștergerea tranzacțiilor",
        MESSAGE: (count) => `Sunteți sigur că doriți să ștergeți ${count} tranzacții?\n\nAceastă acțiune NU poate fi anulată!`,
        CONFIRM: "Da, șterge tranzacțiile",
    },
    RESET_ALL_CONFIRMATION: {
        TITLE: "⚠️ RESETARE COMPLETĂ ⚠️",
        MESSAGE: "Sigur doriți să resetați TOTUL la valorile implicite?\n\nAceasta va:\n• Șterge toate subcategoriile custom\n• Redenumi subcategoriile modificate la numele inițiale\n• ȘTERGE DEFINITIV TOATE TRANZACȚIILE din baza de date\n\n⚠️ ACEASTĂ ACȚIUNE NU POATE FI ANULATĂ! ⚠️\nToate datele financiare vor fi pierdute permanent!",
        CONFIRM: "Continuă",
        FINAL_CHECK_TITLE: "Ultima verificare!",
        FINAL_CHECK_MESSAGE: "Sunteți absolut sigur că doriți să ștergeți TOATE tranzacțiile?\nScrieți 'ȘTERG TOT' în următorul câmp pentru a confirma.",
        FINAL_CHECK_CONFIRM: "Continuă la confirmarea finală",
        PROMPT_TITLE: "Confirmarea finală",
        PROMPT_MESSAGE: "Pentru a confirma ștergerea completă, scrieți exact: ȘTERG TOT",
        PROMPT_EXPECTED_VALUE: "ȘTERG TOT",
        PROMPT_PLACEHOLDER: "Scrieți aici...",
        PROMPT_CONFIRM: "Confirm ștergerea",
        TOAST_PROMPT_ERROR: "Confirmarea nu a fost corectă. Resetarea a fost anulată.",
    },
    SECTION_TITLES: {
        RESET_SETTINGS: "⚠️ Reset la Setările Inițiale",
        RESET_SUBCATEGORIES: "🔄 Reset Subcategorii",
        RESET_ALL: "💥 Reset Complet (PERICULOS)",
        ACCOUNT_INFO: "👤 Informații cont",
        LOGOUT: "🚪 Delogare",
    },
    BUTTONS: {
        RESET_SUBCATEGORIES: "Reset Subcategorii",
        RESET_ALL: "⚠️ Reset Complet",
        LOGOUT: "Delogare",
        RESETTING: "Se resetează...",
    },
    LABELS: {
        RESET_INFO: "Resetați aplicația la configurația inițială. Alegeți ce doriți să resetați:",
        RESET_SUBCATEGORIES_INFO: "Șterge subcategoriile custom și redenumește toate subcategoriile la numele inițiale.",
        RESET_SUBCATEGORIES_WARNING: "ATENȚIE:",
        RESET_SUBCATEGORIES_WARNING_TEXT: "Tranzacțiile de pe subcategorii custom vor fi șterse definitiv. Veți fi informați exact câte tranzacții vor fi afectate.",
        RESET_SUBCATEGORIES_RECOMMENDATION_TITLE: "💡 Recomandare:",
        RESET_SUBCATEGORIES_RECOMMENDATION_TEXT: "Înainte de reset, mutați manual tranzacțiile importante din LunarGrid pe subcategorii pe care doriți să le păstrați.",
        RESET_ALL_INFO: "Resetează subcategoriile ȘI șterge TOATE tranzacțiile definitiv din baza de date.",
        RESET_ALL_WARNING: "Această acțiune NU poate fi anulată!",
        PROCESSING_RESET: "Se procesează resetarea... Vă rugăm să așteptați.",
        EMAIL: "Email:",
        USER_ID: "ID Utilizator:",
        LOGOUT_INFO: "Delogați-vă din aplicație și reveniți la pagina de autentificare.",
        NOT_AVAILABLE: "Nu este disponibil",
    }
};
export const SETTINGS_DARK_MODE_TITLE = 'Tema întunecată (Dark Mode)';
export const SETTINGS_DARK_MODE_DESCRIPTION = 'Activează tema întunecată pentru interfață.';
export const SETTINGS_DARK_MODE_LABEL = 'Activează Dark Mode';
export const SETTINGS_DARK_MODE_RECOMMENDATION = 'Opțional - funcționalitate încă în testare.';
// 🔄 RECURRING TRANSACTIONS CONSTANTS
export const RECURRING_REGENERATE_SUCCESS = 'Tranzacțiile recurente au fost regenerate cu succes';
export const RECURRING_REGENERATE_ERROR = 'Eroare la regenerarea tranzacțiilor recurente';
export const RECURRING_REGENERATE_BUTTON = 'Regenerează tranzacții';
export const RECURRING_REGENERATE_CONFIRMATION = 'Regenerez tranzacțiile recurente pentru următoarele luni?';
export const RECURRING_REGENERATE_DESCRIPTION = 'Regenerează automat tranzacțiile recurente pentru lunile viitoare pe baza regulilor recurente existente.';
// 🗓️ LUNAR GRID CONFIRMATION CONSTANTS
export const LUNAR_GRID_FINAL_CONFIRM_TITLE = 'Confirmare finală pentru LunarGrid';
export const LUNAR_GRID_FINAL_CONFIRM_DESCRIPTION = 'Confirmați modificările înainte de aplicare în LunarGrid.';
export const LUNAR_GRID_FINAL_CONFIRM_LABEL = 'Confirm modificările în LunarGrid';
export const LUNAR_GRID_FINAL_CONFIRM_RECOMMENDATION = '💡 Recomandat să confirmați modificările pentru a preveni pierderea datelor.';
// 🔧 RECURRING TRANSACTIONS PREFERENCES  
export const RECURRING_TRANSACTIONS_PREFERENCES_TITLE = '🔄 Preferințe Tranzacții Recurente';
// 👀 RECURRING LOOK AHEAD SETTINGS
export const RECURRING_LOOK_AHEAD_TITLE = 'Look Ahead pentru Tranzacții Recurente';
export const RECURRING_LOOK_AHEAD_DESCRIPTION = 'Controlează câte zile în viitor să se genereze tranzacții recurente automat.';
export const RECURRING_LOOK_AHEAD_LABEL = 'Generează tranzacții recurente pentru';
export const RECURRING_LOOK_AHEAD_DAYS_30 = '30 de zile în viitor';
export const RECURRING_LOOK_AHEAD_DAYS_90 = '90 de zile în viitor';
export const RECURRING_LOOK_AHEAD_DAYS_180 = '180 de zile în viitor';
export const RECURRING_LOOK_AHEAD_RECOMMENDATION = '💡 Recomandat 90 de zile pentru un echilibru între performanță și utilitate.';
// 📊 RECURRING SHOW GENERATED SETTINGS
export const RECURRING_SHOW_GENERATED_TITLE = 'Afișare Tranzacții Generate';
export const RECURRING_SHOW_GENERATED_DESCRIPTION = 'Controlează dacă tranzacțiile generate automat sunt afișate cu distinctie în LunarGrid.';
export const RECURRING_SHOW_GENERATED_LABEL = 'Evidențiază tranzacțiile generate automat';
export const RECURRING_SHOW_GENERATED_RECOMMENDATION = '💡 Recomandat activat pentru a distinge vizual tranzacțiile manuale de cele auto-generate.';
// 📈 RECURRING STATISTICS
export const RECURRING_STATS_TITLE = 'Statistici Tranzacții Recurente';
export const RECURRING_STATS_TEMPLATES = 'Reguli recurente active';
export const RECURRING_STATS_GENERATED = 'Tranzacții generate';
// 👤 USER PROFILE CONSTANTS - pentru noua pagină de profil utilizator
export const USER_PROFILE = {
    PAGE_TITLE: "Profil Utilizator",
    SECTIONS: {
        PROFILE_INFO: {
            TITLE: "Informații Profil",
            EMAIL_LABEL: "Email",
            USER_ID_LABEL: "ID Utilizator",
            MEMBER_SINCE: "Membru din",
            // Texte adăugate pentru error/loading states
            LOADING_ERROR: "Eroare la încărcarea informațiilor de profil",
        },
        ACCOUNT_SECURITY: {
            TITLE: "Securitate Cont",
            LOGOUT_BUTTON: "Deconectare",
            LOGOUT_DESCRIPTION: "Deconectați-vă din cont",
            // Mesaje toast/error
            LOGOUT_ERROR: "Eroare la deconectare. Te rugăm să încerci din nou.",
            LOGOUT_SUCCESS: "Te-ai deconectat cu succes!",
            LOGOUT_LOADING: "Se deconectează...",
        },
        PRIVACY_DATA: {
            TITLE: "Confidențialitate și Date",
            // Export section
            EXPORT_SECTION_TITLE: "Exportă Datele Tale",
            EXPORT_DATA: "Exportă datele mele",
            EXPORT_BUTTON_LOADING: "Se exportă...",
            EXPORT_DESCRIPTION: "Descarcă toate datele tale într-un fișier JSON pentru backup sau portabilitate.",
            // Delete account section
            DELETE_SECTION_TITLE: "Ștergere Cont",
            DELETE_ACCOUNT: "Șterge contul",
            DELETE_BUTTON_LOADING: "Se șterge...",
            DELETE_WARNING: "Această acțiune este permanentă!",
            DELETE_DESCRIPTION: "Șterge permanent contul tău și toate datele asociate.",
            DELETE_NO_RECOVERY: "Nu există posibilitate de recuperare după ștergere",
            DELETE_RECOMMENDATION: "Recomandăm să exporți datele înainte de ștergere.",
            // Confirmation modal texts
            DELETE_CONFIRM_TITLE: "Ești sigur că vrei să ștergi permanent contul tău? Această acțiune nu poate fi anulată.",
            DELETE_CONFIRM_DETAILS: [
                "Toate datele tale vor fi șterse permanent",
                "Nu vei mai putea accesa contul sau datele",
                "Tranzacțiile, categoriile și conturile vor fi șterse",
                "Nu există posibilitate de recuperare după ștergere"
            ],
            DELETE_CONFIRM_BUTTON: "Șterge Contul",
            DELETE_CONFIRM_CANCEL: "Anulează",
            DELETE_CONFIRM_INPUT_MESSAGE: 'Scrie "ȘTERGE" pentru a confirma ștergerea permanentă a contului.',
            DELETE_FINAL_CONFIRM_TITLE: "Confirmare Finală",
            DELETE_FINAL_CONFIRM_BUTTON: "Confirmă Ștergerea",
            // Toast messages
            EXPORT_SUCCESS: "Datele tale au fost exportate cu succes!",
            EXPORT_ERROR: "Eroare la exportarea datelor. Te rugăm să încerci din nou.",
            EXPORT_DATA_ERROR: "Eroare la preluarea datelor",
            DELETE_TEMP_WARNING: "Funcția de ștergere cont va fi disponibilă în curând. Pentru moment, vei fi deconectat.",
            DELETE_ERROR: "Eroare la ștergerea contului. Te rugăm să contactezi suportul.",
        }
    }
};
// 🗂️ SETTINGS TABS CONSTANTS - pentru sistemul de tabs din pagina de setări
export const SETTINGS_TABS = {
    APP_SETTINGS: "Setări Aplicație",
    FINANCIAL: "Setări Financiare",
    BEHAVIOR: "Comportament",
    DATA_MANAGEMENT: "Gestionare Date",
};
// 🔍 PAGE METADATA CONSTANTS - pentru SEO și document title management
export const PAGE_METADATA = {
    DASHBOARD: {
        title: 'Situația Zilnică - Buzunarul',
        description: 'Monitorizează situația financiară zilnică, solduri și tranzacții recente.',
    },
    TRANSACTIONS: {
        title: 'Tranzacții - Buzunarul',
        description: 'Gestionează și vizualizează toate tranzacțiile financiare într-un tabel complet.',
    },
    LUNAR_GRID: {
        title: 'Grid Lunar - Buzunarul',
        description: 'Planifică și editează tranzacțiile într-o vizualizare calendar lunar intuitivă.',
    },
    OPTIONS: {
        title: 'Opțiuni - Buzunarul',
        description: 'Configurează preferințele aplicației și gestionează setările contului.',
    },
    PROFILE: {
        title: 'Profil Utilizator - Buzunarul',
        description: 'Gestionează informațiile profilului, securitatea contului și exportă datele.',
    },
    AUTH: {
        LOGIN: {
            title: 'Autentificare - Buzunarul',
            description: 'Autentifică-te în aplicația ta financiară personală pentru gestionarea banilor.',
        },
        REGISTER: {
            title: 'Înregistrare - Buzunarul',
            description: 'Creează un cont nou pentru a începe gestionarea finantelor tale personale.',
        },
        CALLBACK: {
            title: 'Procesare autentificare - Buzunarul',
            description: 'Se procesează autentificarea în aplicația ta financiară personală.',
        },
    },
    DEFAULT: {
        title: 'Buzunarul - Gestionare Financiară Personală',
        description: 'Aplicația ta personală pentru gestionarea eficientă a banilor și tranzacțiilor financiare.',
    },
};
// 🪙 BUZUNARUL - Mesaje Contextuale cu Personalitate
// Sistem nou pentru mesaje care se adaptează la contextul financiar
export const BUZUNAR_CONTEXT = {
    // Stări pozitive ale buzunarului
    GOOD_MONTH: 'Buzunarul arată minunat luna asta! 🌟',
    HEALTHY_BALANCE: 'Buzunarul tău e în formă excelentă! 💪',
    SAVINGS_GROWING: 'Bravo! Buzunarul de siguranță crește frumos 📈',
    // Atenționări prietenoase
    LOW_BALANCE: 'Atenție: buzunarul se golește repede! 🚨',
    OVERSPENDING: 'Hmm, pare că scoatem prea mult din buzunar luna asta... 🤔',
    NO_SAVINGS: 'Ce zici să punem ceva deoparte în buzunarul de siguranță? 💡',
    // Mesaje pentru utilizatori noi
    FIRST_TIME: 'Bine ai venit! Să-ți organizăm buzunarul împreună 🤝',
    GETTING_STARTED: 'Hai să îți învățăm trucurile pentru un buzunar fericit! ✨',
    FIRST_TRANSACTION: 'Prima mișcare în buzunar e mereu specială! 🎉',
    // Realizări și milestones
    MILESTONE: (amount) => `Wow! Ai depășit ${amount} RON în buzunar! 🎉`,
    STREAK_TRACKING: (days) => `${days} zile la rând de organizare a buzunarului! 🔥`,
    CATEGORY_MASTER: (category) => `Ești campion la compartimentul ${category}! 🏆`,
    // Sfaturi educaționale
    EDUCATION: {
        SAVINGS_TIP: '💡 Buzunarul tău înțelept: Economisește 10% din venituri lunar!',
        CATEGORIES_TIP: '🎯 Pro tip: Organizează buzunarul în compartimente pentru control mai bun',
        BALANCE_TIP: '⚖️ Balanța perfectă: venituri > cheltuieli = buzunar fericit!',
        TRACKING_TIP: '📊 Urmărește zilnic buzunarul pentru a-ți forma obiceiuri sănătoase'
    },
    // Mesaje de încurajare
    ENCOURAGEMENT: {
        COMEBACK: 'Nu-i bai, buzunarul tău se poate recupera! Hai să facem un plan 💪',
        KEEP_GOING: 'Ești pe drumul cel bun! Buzunarul îți mulțumește 🙏',
        SMALL_STEPS: 'Fiecare bănuț contează - buzunarul tău crește pas cu pas! 👣',
        CONSISTENCY: 'Consistency is key - continua să-ți organizezi buzunarul! 🔑'
    }
};
// 🪙 BUZUNARUL - Authentication UI cu Personalitate
// Toate textele pentru formularele de autentificare și înregistrare
export const AUTH_UI = {
    // Titluri și headers
    REGISTRATION_TITLE: 'Alătură-te comunității Buzunar! 🪙',
    EMAIL_APPROVED: 'Email aprobat pentru testare ✅',
    EMAIL_NOT_APPROVED: 'Email-ul nu este în lista de testeri aprobați 🚫',
    // Separatori și conectori
    DIVIDER_OR: 'sau',
    // Mesaje Google OAuth
    GOOGLE_AUTO_CREATE: 'Google va crea automat un buzunar dacă nu ai unul deja',
    GOOGLE_AUTO_CREATE_REGISTER: 'Google va crea automat buzunarul folosind adresa ta de email',
    // Link-uri de switch între formulare
    SWITCH_TO_REGISTER: 'Nu ai buzunar? Creează-ți unul! 🎯',
    SWITCH_TO_LOGIN: 'Ai deja buzunar? Intră în el! 🔑',
    // Indicații pentru parolă
    PASSWORD_MIN_CHARS: '(min. 6 caractere)',
    PASSWORD_HINT: 'Parolă puternică pentru buzunarul tău sigur',
    // Mesaje de validare inline
    EMAIL_FORMAT_INVALID: 'Adresa de email nu pare corectă...',
    PASSWORD_TOO_SHORT: 'Parola e prea scurtă pentru siguranța buzunarului',
    PASSWORDS_DONT_MATCH: 'Parolele nu se potrivesc',
    // Mesaje de încurajare
    WELCOME_BACK: 'Bine ai revenit la buzunarul tău! 🤗',
    FIRST_TIME_HERE: 'Prima vizită? Hai să-ți facem buzunarul! ✨'
};
// 🪙 BUZUNARUL - Validation Messages cu Tonul Prietenos
// Toate mesajele de validare transformate cu personalitatea buzunar
export const VALIDATION_MESSAGES = {
    // Parole și autentificare
    PASSWORD_TOO_WEAK: 'Parola e prea slabă pentru buzunarul tău. Trebuie să aibă cel puțin 6 caractere! 🔐',
    EMAIL_ALREADY_EXISTS: 'Acest email are deja un buzunar. Încearcă să te autentifici! 📧',
    // Validări pentru sume - cu personalitatea buzunar
    AMOUNT_MIN_VALUE: (minValue) => `Buzunarul acceptă minim ${minValue} RON 💰`,
    AMOUNT_MAX_VALUE: (maxValue) => `Suma e prea mare pentru buzunar! Max ${maxValue.toLocaleString('ro-RO')} RON 🚫`,
    AMOUNT_NOT_NEGATIVE: 'Buzunarul nu poate avea sume negative! 🙅‍♂️',
    AMOUNT_REQUIRED: 'Buzunarul are nevoie de o sumă! 💸',
    // Validări pentru text
    TEXT_MIN_LENGTH: (minLength) => `Textul trebuie să aibă minim ${minLength} caractere pentru a organiza buzunarul 📝`,
    TEXT_MAX_LENGTH: (maxLength) => `Textul e prea lung pentru buzunar! Max ${maxLength} caractere 📏`,
    TEXT_REQUIRED: 'Buzunarul are nevoie de o descriere! ✍️',
    // Validări financiare specifice
    NEGATIVE_STARTING_BALANCE: 'Buzunarul nu poate începe cu sold negativ! 📉',
    NO_TRANSACTIONS_TO_CALCULATE: 'Nu există mișcări în buzunar pentru calcul 🤷‍♂️',
    // Validări pentru categorii
    CATEGORY_REQUIRED: 'Alege un compartiment din buzunar! 🗂️',
    SUBCATEGORY_REQUIRED: 'Selectează un sub-compartiment! 📁',
    // Validări pentru date
    DATE_REQUIRED: 'Buzunarul are nevoie de o dată! 📅',
    DATE_IN_FUTURE: 'Data nu poate fi în viitor! ⏰',
    DATE_TOO_OLD: 'Data e prea veche pentru buzunarul tău 📰'
};
// 🪙 BUZUNARUL - Placeholder Texts Extinse
// Completarea constantelor PLACEHOLDERS cu textele lipsă
export const ADDITIONAL_PLACEHOLDERS = {
    // Descrieri și comentarii
    ADD_DESCRIPTION: 'Spune-ne despre această mișcare... 💭',
    SEARCH_DESCRIPTION: 'Caută în mișcările din buzunar... 🔍',
    // Selecții pentru formulare
    SELECT_CATEGORY: 'Alege compartimentul din buzunar 🗂️',
    SELECT_SUBCATEGORY: 'Selectează sub-compartimentul 📁',
    SELECT_TYPE_FIRST: 'Selectează mai întâi tipul mișcării ⬆️',
    // Intrări de valori
    ENTER_VALUE: 'Cât punem în buzunar? 💰',
    ENTER_AMOUNT: 'Introdu suma pentru buzunar 🪙',
    // Căutări și filtre
    SEARCH_PLACEHOLDER: 'Caută prin buzunar... 🔎',
    FILTER_PLACEHOLDER: 'Filtrează conținutul buzunarului 🎯',
    // Nume și denumiri
    ACCOUNT_NAME: 'Numele buzunarului (ex: Buzunar Principal) 👛',
    DESCRIPTION_OPTIONAL: 'Descriere opțională pentru buzunar... 📖',
    // Filtre sumă
    AMOUNT_MIN: 'Min',
    AMOUNT_MAX: 'Max'
};
// 🪙 BUZUNARUL - Console Messages pentru Dezvoltatori
// Mesaje de debug cu personalitatea buzunar (pentru amuzamentul dezvoltatorilor)
export const CONSOLE_MESSAGES = {
    // Erori de formatare
    FORMAT_CURRENCY_INVALID: 'formatCurrency: Buzunarul nu poate formata o sumă invalidă! 💸',
    FORMAT_CURRENCY_COMPACT_INVALID: 'formatCurrencyCompact: Această sumă nu încape în buzunar! 🚫',
    FORMAT_CURRENCY_GRID_INVALID: 'formatCurrencyForGrid: Buzunarul nu poate afișa această sumă în tabel! 📊',
    // Erori de date
    FORMAT_DATE_ERROR: 'Eroare la formatarea datei în buzunar: 📅',
    FORMAT_DAY_MONTH_INVALID: 'formatDayMonth: Zi sau lună invalidă în buzunar 🗓️',
    FORMAT_MONTH_YEAR_INVALID: 'formatMonthYear: Lună invalidă în buzunar 📆',
    // Erori de componente
    REACT_COMPONENT_ERROR: 'Eroare în componenta buzunarului: 🐛',
    COMPONENT_PRELOAD_FAILED: 'Nu am putut pregăti componenta buzunarului din timp: 📦',
    // Erori de validare
    VALIDATION_FAILED: 'Validarea buzunarului a eșuat: ❌',
    DATA_INTEGRITY_ERROR: 'Datele din buzunar sunt corupte: 💾',
    // Warnings amuzante
    PERFORMANCE_WARNING: 'Buzunarul se mișcă încet - optimizare necesară! 🐌',
    MEMORY_WARNING: 'Buzunarul folosește prea multă memorie! 🧠',
    // Success cu personalitate
    TRANSACTION_SAVED: 'Mișcarea a fost pusă în buzunar cu succes! ✅',
    DATA_SYNCED: 'Buzunarul e sincronizat perfect! 🎯'
};
// 🪙 BUZUNARUL - Daily Situation UI Messages
// Texte specifice pentru componenta de situație zilnică
export const DAILY_SITUATION_UI = {
    // Empty states
    ADD_FIRST_TRANSACTION: (date) => `Pune prima mișcare în buzunar pentru ${date} 🎯`,
    // Labels și descrieri
    AVAILABLE_BALANCE_LABEL: 'Bani disponibili în buzunar 💰',
    // Placeholder texts
    ADD_DESCRIPTION_PLACEHOLDER: 'Spune-ne despre această mișcare... 📝',
    // Quick Add FAB
    QUICK_ADD_ARIA_LABEL: 'Pune repede o mișcare în buzunar 🚀',
    QUICK_ADD_TITLE: 'Adaugă rapid în buzunar (Ctrl+N) ⚡',
};
// 🪙 BUZUNARUL - Lunar Grid UI Messages
// Texte specifice pentru grid-ul de tranzacții
export const LUNAR_GRID_UI = {
    // Titluri și labels
    GRID_TITLE: 'Organizatorul Buzunarului',
    // Acțiuni pentru grid
    EXPAND_ALL: 'Extinde',
    COLLAPSE_ALL: 'Restrânge',
    RESET_COLUMNS: 'Resetează coloanele buzunarului 🔄',
    TOGGLE_FULLSCREEN: 'Modul ecran complet pentru buzunar 🖥️',
};
// 🪙 BUZUNARUL - Transaction Table UI Messages
// Texte specifice pentru tabelul de tranzacții
export const TRANSACTION_TABLE_UI = {
    // Placeholders și valori implicite
    EMPTY_CELL_PLACEHOLDER: '—',
    // Acțiuni pentru coloane și rânduri
    DRAG_TO_REORDER: 'Trage pentru a reorganiza în buzunar 🔄',
    MOVE_COLUMN_UP: 'Mută compartimentul în sus ⬆️',
    MOVE_COLUMN_DOWN: 'Mută compartimentul în jos ⬇️',
    // Actions shortcuts
    SAVE_SHORTCUT: 'Salvează în buzunar (Enter) ✅',
    CANCEL_SHORTCUT: 'Anulează modificarea (Escape) ❌',
};
// 🪙 BUZUNARUL - Charts UI Messages  
// Labels și texte pentru componente de grafice
export const CHARTS_UI = {
    // Labels pentru tipuri de date
    BALANCE: 'Balanță',
    INCOME: 'Venituri',
    EXPENSES: 'Cheltuieli',
    NET: 'Net',
    SAVINGS: 'Economii',
    // Empty states pentru grafice
    NO_DATA: 'Nu există date pentru grafic 📊',
    LOADING_CHART: 'Se încarcă graficul...',
};
// 🪙 BUZUNARUL - Modal UI Messages
// Texte specifice pentru modaluri și dialoguri
export const MODAL_UI = {
    // Placeholders generale
    PROMPT_PLACEHOLDER: 'Spune-ne ce vrei să faci cu buzunarul... 💭',
    // Butoane și acțiuni
    CONFIRM_BUTTON: 'Da, sigur! ✅',
    CANCEL_BUTTON: 'Nu, las așa ❌',
    OK_BUTTON: 'OK 👍',
    // Confirmări pentru ștergere
    DELETE_CONFIRMATION: 'Sigur scoți acest element din buzunar? Nu se poate da înapoi! 🗑️',
    // Labels pentru accesibilitate
    MODAL_TITLE_LABEL: 'modal-title',
};
